export default {"src":"/_next/static/media/cookie.df77791f.svg","height":46,"width":46};